import { NavItem } from './navItem.interface';

export const navItems: NavItem[] = [
    {
        label: 'HEADER.HOME',
        link: 'https://purso.fi/',
    },
    {
        label: 'HEADER.PROFILES_AND_COMPONENTS',
        link: 'https://purso.fi/profiilit-ja-komponentit/',
        children: [
            {
                label: 'HEADER.CUSTOMER_PROFILES',
                link: 'https://purso.fi/profiilit-ja-komponentit/asiakasprofiilit/',
            },
            {
                label: 'HEADER.STANDARD_PROFILES',
                link: 'https://purso.fi/profiilit-ja-komponentit/vakioprofiilit/',
            },
            {
                label: 'HEADER.COMPONENTS',
                link: 'https://purso.fi/profiilit-ja-komponentit/komponentit/',
            },
            {
                label: 'HEADER.VEHICLE_PROFILES',
                link: 'https://purso.fi/profiilit-ja-komponentit/ajoneuvoprofiilit/',
            },
            {
                label: 'HEADER.COOLING_SOLUTIONS',
                link: 'https://pursoalucool.fi/',
            },
            {
                label: 'HEADER.ALUDO',
                link: 'https://purso.fi/aludo/',
                children: [
                    { label: 'HEADER.ALUDO_118', link: 'https://purso.fi/aludo/aludo-118/' },
                    { label: 'HEADER.ALUDO_156', link: 'https://purso.fi/aludo/aludo-156/' },
                    { label: 'HEADER.ALUDO_185', link: 'https://purso.fi/aludo/aludo-185/' },
                ],
            },
            {
                label: 'HEADER.REFERENCES',
                link: 'https://purso.fi/referenssikategoria/profiilit-ja-komponentit/',
            },
        ],
    },
    {
        label: 'HEADER.CONSTRUCTION',
        link: 'https://purso.fi/rakentaminen/',
        children: [
            {
                label: 'HEADER.PRODUCTS',
                link: 'https://purso.fi/tuotekategoria/rakentaminen/',
            },
            {
                label: 'HEADER.MATERIAL_BANK',
                link: 'https://purso.fi/rakentaminen/materiaalipankki/',
                children: [
                    {
                        label: 'HEADER.DESIGN_MATERIAL',
                        link: 'https://purso.fi/rakentaminen/materiaalipankki/suunnittelumateriaali/',
                    },
                    {
                        label: 'HEADER.CE_MARKINGS',
                        link: 'https://purso.fi/rakentaminen/materiaalipankki/ce-merkinnat/',
                    },
                    {
                        label: 'HEADER.MANUFACTURING_INSTRUCTIONS',
                        link: 'https://purso.fi/rakentaminen/materiaalipankki/valmistusohjeet/',
                    },
                    {
                        label: 'HEADER.PRICE_LIST',
                        link: 'https://purso.fi/rakentaminen/materiaalipankki/hinnasto/',
                    },
                    {
                        label: 'HEADER.LINKS',
                        link: 'https://purso.fi/rakentaminen/materiaalipankki/linkit/',
                    },
                    {
                        label: 'HEADER.BULLETINS',
                        link: 'https://purso.fi/en/building/material-library/tiedotteet/',
                    },
                ],
            },
            {
                label: 'HEADER.PURSOCAL',
                link: 'https://purso.fi/rakentaminen/valmistajalle/pursocal/',
            },
            {
                label: 'HEADER.REFERENCES',
                link: 'https://purso.fi/referenssikategoria/rakentaminen/',
            },
        ],
    },
    {
        label: 'HEADER.LIGHTING',
        link: 'https://purso.fi/valaistus/',
        children: [
            {
                label: 'HEADER.USE_CASES',
                link: '#',
                children: [
                    {
                        label: 'HEADER.INDUSTRY',
                        link: 'https://purso.fi/teollisuusvalaisimet/',
                    },
                    {
                        label: 'HEADER.STORES',
                        link: 'https://purso.fi/myymalavalaistus/',
                    },
                    {
                        label: 'HEADER.SPORTS_FACILITIES',
                        link: 'https://purso.fi/urheiluhallin-valaistus/',
                    },
                    {
                        label: 'HEADER.PARKING_FACILITIES',
                        link: 'https://purso.fi/pysakointialueen-valaistus/',
                    },
                    {
                        label: 'HEADER.PUBLIC_FACILITIES',
                        link: 'https://purso.fi/julkisten-tilojen-valaistus/',
                    },
                    {
                        label: 'HEADER.OFFICES',
                        link: 'https://purso.fi/toimistovalaistus/',
                    },
                    {
                        label: 'HEADER.LOGISTICS',
                        link: 'https://purso.fi/logistiikkatilojen-valaistus/',
                    },
                    {
                        label: 'HEADER.HOSPITALS',
                        link: 'https://purso.fi/sairaalavalaistus/',
                    },
                    {
                        label: 'HEADER.SHOPPING_CENTERS',
                        link: 'https://purso.fi/kauppakeskusten-valaistus/',
                    },
                    {
                        label: 'HEADER.SCHOOLS',
                        link: 'https://purso.fi/kouluvalaistus/',
                    },
                ],
            },
            {
                label: 'HEADER.PRODUCTS',
                link: 'https://purso.fi/tuotekategoria/valaistus/',
            },
            {
                label: 'HEADER.REFERENCES',
                link: 'https://purso.fi/referenssikategoria/valaistus/',
            },
            {
                label: 'HEADER.SNEP',
                link: 'https://snep.purso.fi/',
            },
        ],
    },
    {
        label: 'HEADER.CAREER_AT_PURSO',
        link: 'https://purso.fi/purso/ura-pursolla/',
    },
    {
        label: 'HEADER.RESPONSIBILITY',
        link: 'https://purso.fi/purso/vastuullisuus-pursolla/',
        children: [
            {
                label: 'HEADER.RESPONSIBILITY_AT_PURSO',
                link: 'https://purso.fi/purso/vastuullisuus-pursolla/',
            },
            {
                label: 'HEADER.GREENLINE',
                link: 'https://purso.fi/greenline/',
            },
        ],
    },
    {
        label: 'HEADER.CONTACT_US',
        link: 'https://purso.fi/ota-yhteytta/',
        children: [
            {
                label: 'HEADER.CONTACT_DETAILS',
                link: 'https://purso.fi/yhteystiedot/',
            },
            {
                label: 'HEADER.LOCATIONS',
                link: 'https://purso.fi/toimipisteet/',
            },
        ],
    },
];